import React, { ReactElement } from "react"
import "twin.macro"
const nextI18NextConfig = require("../../../next-i18next.config.js").i18n
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Layout } from "../../layouts/layout"
import { Authentication, AuthenticatonPage } from "../../components/authentication"

export async function getStaticProps(props: any) {
  const metadata = { title: `Sign up` }
  return {
    props: {
      ...(await serverSideTranslations(props.locale, undefined, nextI18NextConfig)),
      metadata: metadata,
    },
  }
}

const JoinController = () => {
  return <Authentication view={AuthenticatonPage.Join} />
}

export default JoinController

// Set the page Layout
JoinController.getLayout = function getLayout(page: ReactElement) {
  return Layout(page)
}
